/**
 * Locale preference persistence (TMMRSL-0005) — the language only, beside the
 * theme mode (`tmm_reseller_admin.themeMode`). Ported from tmm-app TMMAPP-0001; the
 * storage key is this console's (`tmm_reseller_admin.locale`). Never a token, never
 * bootstrap data. Storage access is try/catch-guarded: private mode reads as
 * "no preference" and writes are dropped.
 */
import { LOCALE_STORAGE_KEY, normalizeLocale, type SupportedLocale } from './constants';

export function readStoredLocale(): SupportedLocale | null {
  try {
    return normalizeLocale(localStorage.getItem(LOCALE_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function writeStoredLocale(locale: SupportedLocale): void {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    /* localStorage unavailable — preference not persisted */
  }
}
